module.exports = __webpack_public_path__ + "static/media/Amelia_Island_FL_History_Museum_Spanish_Port_diorama THUMBNAIL.d32c3071.webp";